export default {
    table: {
        clickModify: true,
        selectBtn: true,
        leftOperation: true,
        leftWidth: 160,
        height: 300,
        columns: [
            {
                label: '运单ID',
                prop: 'id',
                sort: true,
                width: 150,
                amendState: true
            },
            {
                label: '运输单号',
                prop: 'taskNo',
                sort: true,
                width: 150
            },
            {
                label: '相关单号', // TODO
                prop: 'whCode',
                sort: true,
                width: 150
            },
            {
                label: '分公司名称',
                prop: 'companyName',
                sort: true,
                width: 150
            },
            {
                label: '仓库名称',
                prop: 'whName',
                sort: true,
                width: 182
            },
            {
                label: '客户订单号',
                sort: true,
                prop: 'customerOrderNo',
                width: 120
            },
            {
                label: '平台单号',
                sort: true,
                prop: 'platformOrderNo',
                width: 120
            },
            {
                label: '关联单号',
                sort: true,
                prop: 'relationOrderNo',
                width: 120
            },
            {
                label: '物流订单号', // TODO
                sort: true,
                prop: 'waybillNo',
                width: 120
            },
            {
                label: '运单状态',
                prop: 'taskStatusName',
                sort: true,
                width: 160
            },
            {
                label: '创建人',
                prop: 'createUserName',
                sort: true,
                width: 160
            },
            {
                label: '创建时间',
                prop: 'createTime',
                sort: true,
                width: 160
            },
            {
                label: '最后修改人',
                prop: 'updateUserName',
                sort: true,
                width: 160
            },
            {
                label: '最后修改时间',
                prop: 'updateTime',
                sort: true,
                width: 160
            }
        ]
    },
    page: {
        layout: 'total, sizes, prev, pager, next',
        pageSize: 10,
        pageSizes: [
            10,
            20,
            30,
            50
        ]
    }
};
